import BaseDataProvider from "../services/BaseDataProvider";

export class Template900DataProvider extends BaseDataProvider {
    _getFullObject(context = {}) {
        return 12857;
    }

    getScrollObject(context) {
        return 12857;
    }
    __getNumFromInfo(info) {
        let num = 0;

        Object.values(info).forEach(inf => {
            num += inf[1];
        });

        return num;
    }

    getNum(context) {
        const info = this.getBlocksInfo(context);
        return this.__getNumFromInfo(info);
    }

    getScrollNum(context) {
        const info = this.getScrollBlocksInfo(context);
        return this.__getNumFromInfo(info);
    }

    getBlocksInfo(context) {
        const s1024 = {
            sidebarList: [0, 3],
            sidebarImage: [0, 1],
            intextSimple: [0, 1],
            intextList: [0, 1],
            intextImages: [0, 2],
            intextWide: [0, 1],
            bottomList: [0, 3],
            bottomLarge: [0, 1]
        };
        const s768 = {
            intextSimple: [0, 1],
            intextList: [0, 1],
            intextImages: [0, 2],
            intextWide: [0, 1],
            bottomList: [0, 3],
            bottomLarge: [0, 1]
        };
        const s320 = {
            intextSimple: [0, 1],
            intextList: [0, 1],
            intextImages: [0, 1],
            intextWide: [0, 1],
            bottomList: [0, 3],
            bottomLarge: [0, 1]
        };

        return {
            1024: s1024,
            768: s768,
            320: s320
        }[context.screen];
    }

    getScrollBlocksInfo(context) {
        const s1024 = {
            single: [0, 7]
        };
        const s768 = {
            single: [0, 5]
        };
        const s320 = {
            single: [0, 3]
        };

        return {
            1024: s1024,
            768: s768,
            320: s320
        }[context.screen];
    }

    reindexDesktop(teasers) {
        let reindex = [
            [1, 10],
            [2, 11],
            [3, 12],
            [4, 13],
            [5, 1],
            [6, 2],
            [7, 3],
            [8, 4],
            [9, 5],
            [10, 6],
            [11, 7],
            [12, 8],
            [13, 9]
        ];
        this.reindex(teasers, reindex);
    }

    async loadInitialData(context, scrollNum) {
        const num = this.getNum(context) + this.getScrollNum(context);
        const object = this.getObject(context);
        const teasers = await this.load(object, num, context, scrollNum);

        if (context.screen >= 1024) {
            this.reindexDesktop(teasers);
        }

        const data = this.spliceData(teasers, this.getBlocksInfo(context) || {});
        const scrollData = [this.spliceData(teasers, this.getScrollBlocksInfo(context) || {})];

        return { data, scrollData };
    }

    async loadScrollData(context, scrollNum) {
        const num = this.getScrollNum(context);
        const object = this.getScrollObject(context);
        const teasers = await this.load(object, num, context, scrollNum);
        const scrollData = [this.spliceData(teasers, this.getScrollBlocksInfo(context))];
        return { scrollData };
    }

    preprocessTeasers(teasers, context, scrollNum, object) {
        const result = super.preprocessTeasers(teasers, context, scrollNum, object);

        result.forEach(teaser => {
            if (!teaser.image_color_primary) {
                teaser.image_color_primary = [0, 0, 0];
            }
        });

        return result;
    }
}

export default new Template900DataProvider();
